import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
	{
		path: "/users",
		exact: true,
		auth: true,
		component: Loadable({
			loader: () => import("./pages/list/index"),
			loading: LoadingComponent
		})
	},
	{
		path: "/users/:user_id/",
		exact: true,
		auth: true,
		component: Loadable({
			loader: () => import("./pages/edit/index"),
			loading: LoadingComponent
		})
	}
];



// WEBPACK FOOTER //
// ./src/modules/user/routes.js